import type { User } from '@/types'

export interface UsersState {
  users: User[]
  selectedUser: User | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    role: string | null
    isActive: boolean | null
  }
}

export const getInitialState = (): UsersState => ({
  users: [],
  selectedUser: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    role: null,
    isActive: null,
  },
})

export const initialState: UsersState = getInitialState()

export const resetState = (state: UsersState): void => {
  const initial = getInitialState()
  state.users = initial.users
  state.selectedUser = initial.selectedUser
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
